import type { WOClipboardContext } from "./formatSessionClipboard";

type ComponentInfo = WOClipboardContext["components"][number];
type AssigneeInfo = WOClipboardContext["woAssignees"][number];

// Structural shape of the fields both apps' TicketRetrieve expose that feed the
// clipboard header. Kept minimal so the same helper serves the management and
// field generated clients without depending on either's concrete TicketRetrieve.
type TicketLike = {
  location?: { name?: string | null } | null;
  turbine?: { serial_number?: string | null } | null;
  items?: Array<{ component: ComponentInfo }> | null;
  client_case_nr?: string | null;
  deadline?: string | null;
  ticket_number?: number | null;
  assignees?: Array<{ assignee: AssigneeInfo }> | null;
};

export function buildWOClipboardContext(ticket: TicketLike): WOClipboardContext {
  return {
    locationName: ticket.location?.name,
    turbineSerialNumber: ticket.turbine?.serial_number,
    components: (ticket.items ?? []).map((item) => item.component).filter(Boolean),
    caseNumber: ticket.client_case_nr,
    deadline: ticket.deadline,
    ticketNumber: ticket.ticket_number,
    woAssignees: (ticket.assignees ?? []).map((a) => a.assignee),
  };
}
